import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Dialog } from '@unite-us/ui';
import EditButton from '../EditButton';
import './EditModal.scss';
import generateUUID from '../../utils/generateUUID';
import AddCirclePlusButton from '../AddCirclePlusButton';
export var EditModal = /*#__PURE__*/function (_Component) {
  _inherits(EditModal, _Component);
  var _super = _createSuper(EditModal);
  function EditModal(props) {
    var _this;
    _classCallCheck(this, EditModal);
    _this = _super.call(this, props);
    _this.state = {
      id: generateUUID(),
      modalIsOpen: false
    };
    _this.openModal = _this.openModal.bind(_assertThisInitialized(_this));
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(EditModal, [{
    key: "openModal",
    value: function openModal() {
      var _this2 = this;
      this.setState({
        modalIsOpen: true
      }, function () {
        _this2["editModal-".concat(_this2.state.id)].openDialog().then(function () {
          _this2.setState({
            modalIsOpen: false
          });
        });
        _this2.props.modalOpenCallback();
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this["editModal-".concat(this.state.id)].closeDialog();
    }
  }, {
    key: "transformIdToAriaLabel",
    value: function transformIdToAriaLabel(id) {
      var _context;
      return _trimInstanceProperty(_context = id.replace(/-/g, ' ').replace('btn', '')).call(_context);
    }
  }, {
    key: "render",
    value: function render() {
      var _context2,
        _this3 = this;
      var _this$props = this.props,
        actions = _this$props.actions,
        addButtonId = _this$props.addButtonId,
        addLabelText = _this$props.addLabelText,
        bodyStyle = _this$props.bodyStyle,
        children = _this$props.children,
        editButtonId = _this$props.editButtonId,
        editLabelText = _this$props.editLabelText,
        header = _this$props.header,
        id = _this$props.id,
        removeCloseIcon = _this$props.removeCloseIcon,
        showAdd = _this$props.showAdd,
        showEdit = _this$props.showEdit,
        size = _this$props.size,
        ingested = _this$props.ingested;
      var childrenWithFuncs = _mapInstanceProperty(_context2 = React.Children).call(_context2, children, function (child) {
        return /*#__PURE__*/React.cloneElement(child, {
          closeModal: _this3.closeModal,
          modalIsOpen: _this3.state.modalIsOpen
        });
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "edit-modal"
      }, showEdit && /*#__PURE__*/React.createElement(EditButton, {
        edit: this.openModal,
        id: editButtonId,
        labelText: editLabelText,
        "aria-label": this.transformIdToAriaLabel(editButtonId),
        toolTipText: ingested ? "This insurance record cannot be edited because it was ingested from a roster." : undefined
      }), /*#__PURE__*/React.createElement("div", {
        id: editLabelText
      }), showAdd && /*#__PURE__*/React.createElement(AddCirclePlusButton, {
        addHandler: this.openModal,
        id: addButtonId,
        labelText: addLabelText,
        "aria-label": this.transformIdToAriaLabel(addButtonId)
      }), /*#__PURE__*/React.createElement(Dialog, {
        actions: actions,
        bodyStyle: bodyStyle,
        id: id,
        onCloseModal: this.closeModal,
        onRequestClose: this.closeModal,
        ref: function ref(el) {
          _this3["editModal-".concat(_this3.state.id)] = el;
        },
        removeCloseIcon: removeCloseIcon,
        size: size,
        title: header,
        type: "form"
      }, childrenWithFuncs));
    }
  }]);
  return EditModal;
}(Component);
EditModal.propTypes = {
  actions: PropTypes.node,
  addButtonId: PropTypes.string,
  addLabelText: PropTypes.string,
  bodyStyle: PropTypes.object,
  children: PropTypes.node,
  editButtonId: PropTypes.string,
  editLabelText: PropTypes.string,
  formName: PropTypes.string,
  header: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  modalOpenCallback: PropTypes.func,
  removeCloseIcon: PropTypes.bool,
  reset: PropTypes.func,
  showAdd: PropTypes.bool,
  showEdit: PropTypes.bool.isRequired,
  size: PropTypes.oneOf(['mini', 'small', 'normal', 'large', 'jumbo', 'full']),
  ingested: PropTypes.bool
};
EditModal.defaultProps = {
  addButtonId: 'add',
  addLabelText: 'Add',
  editButtonId: 'edit',
  editLabelText: 'Edit',
  fields: [],
  initialValues: {},
  modalOpenCallback: noop,
  removeCloseIcon: false,
  showAdd: false,
  showEdit: true,
  size: undefined,
  ingested: false
};
export default EditModal;
//# sourceMappingURL=EditModal.js.map